import { Claims, UserSummary, UserTypes } from "..";

export enum Dashboards {
    Admin = "Admin",
    Distribution = "Distribution",
    Invoicing = "Invoicing",
    Lab = "Lab",
    MedicalChart = "Medical Chart Review",
    Processing = "Processing",
    QualityAssurance = "Quality Assurance",
    Recovery = "Recovery",
    Referral = "Referral",
    Surgery = "Surgery",
}

export interface Dashboard {
    name: string;
    path: string;
}

const AdminDashboard: Dashboard = {
    name: Dashboards.Admin,
    path: "admin",
};

const DistributionDashboard: Dashboard = {
    name: Dashboards.Distribution,
    path: "distribution",
};

const InvoicingDashboard: Dashboard = {
    name: Dashboards.Invoicing,
    path: "invoicing",
};

const LabDashboard: Dashboard = {
    name: Dashboards.Lab,
    path: "lab",
};

const MedicalChartDashboard: Dashboard = {
    name: Dashboards.MedicalChart,
    path: "medical-chart",
};

const ProcessingDashboard: Dashboard = {
    name: Dashboards.Processing,
    path: "processing",
};

const QualityAssuranceDashboard: Dashboard = {
    name: Dashboards.QualityAssurance,
    path: "quality-assurance",
};

const RecoveryDashboard: Dashboard = {
    name: Dashboards.Recovery,
    path: "recovery",
};

const ReferralDashboard: Dashboard = {
    name: Dashboards.Referral,
    path: "referral",
};

const SurgeryDashboard: Dashboard = {
    name: Dashboards.Surgery,
    path: "surgery",
};

export const TeamDashboardsList: Dashboard[] = [
    AdminDashboard,
    ReferralDashboard,
    RecoveryDashboard,
    LabDashboard,
    MedicalChartDashboard,
    ProcessingDashboard,
    DistributionDashboard,
    QualityAssuranceDashboard,
];

export const getDashboardsForUser = ({ roles, permissions }: UserSummary): Dashboard[] => {
    const canViewInternal = permissions.some((p) => p === Claims.ViewInternal);
    const canViewSurgery = permissions.some((p) => p === Claims.ViewSurgery);
    const canViewInvoicing = permissions.some((p) => p === Claims.ViewInvoice);

    if (roles.some((r) => r === UserTypes.SurgeryScheduler || r === UserTypes.Surgeon) && canViewSurgery) {
        return [SurgeryDashboard];
    }
    const result = [];
    if (canViewInternal) {
        result.push(...TeamDashboardsList);
    }
    if (canViewSurgery) {
        result.push(SurgeryDashboard);
    }
    if (canViewInvoicing) {
        result.push(InvoicingDashboard);
    }
    return result;
};
